import { onlyNumbers } from "../../utils/admin-utils";
import { buildSegmentationOptions } from "../../utils/segmentation-utils";

export const variluxGoalsFormConfig = ({
	variluxGoals,
	segmentations = [],
	loadingSegmentations = false,
	isEditing = false
} = {}) => {
	const segmentationOptions = buildSegmentationOptions(segmentations);

	return [
		{
			fields: [
				{
					name: "segmentation",
					label: "Tamanho do cliente *",
					type: "select",
					placeholder: loadingSegmentations ? "Carregando..." : "Selecione",
					options: segmentationOptions,
					defaultValue:
						variluxGoals?.idSegmentation !== undefined && variluxGoals?.idSegmentation !== null
							? String(variluxGoals.idSegmentation)
							: "",
					disabled: loadingSegmentations || isEditing,
					columns: 12
				},
				{
					name: "additionalPairsYear1",
					label: "Pares adicionais Ano 1 *",
					type: "text",
					placeholder: "0",
					defaultValue: onlyNumbers(variluxGoals?.additionalPairsYear1),
					columns: 4,
					onChange: onlyNumbers
				},
				{
					name: "additionalPairsYear2",
					label: "Pares adicionais Ano 2 *",
					type: "text",
					placeholder: "0",
					defaultValue: onlyNumbers(variluxGoals?.additionalPairsYear2),
					columns: 4,
					onChange: onlyNumbers
				},
				{
					name: "additionalPairsYear3",
					label: "Pares adicionais Ano 3 *",
					type: "text",
					placeholder: "0",
					defaultValue: onlyNumbers(variluxGoals?.additionalPairsYear3),
					columns: 4,
					onChange: onlyNumbers
				}
			]
		}
	];
};